<template>
  <BravadoTheme class="layout layout--clear-with-nav">
    <div :class="rootClass">
      <ClientOnly>
        <TopNotification />
      </ClientOnly>
      <Header :only-logo="true" />
      <nuxt />
      <GlobalComponents />
    </div>
  </BravadoTheme>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import defaultLayoutMixin from '~/layouts/defaultLayoutMixin';

export default defineComponent({
  name: 'ClearLayout',
  mixins: [defaultLayoutMixin],
  computed: {
    rootClass() {
      return ['clear-with-nav-layout'];
    },
  },
});
</script>

<style scoped lang="scss">
.clear-with-nav-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>
